<template>
  <div>
    <PlanComponentVue mode="view" />
  </div>
</template>
<script>
import PlanComponentVue from "./PlanComponent.vue";

export default {
  components: {
    PlanComponentVue,
  },
};
</script>
